export default __webpack_public_path__ + "static/media/keto_box.109aa666.jpg";